import { mapProps, mapReadPretty, connect } from '@formily/vue'
import { defineComponent, h } from 'vue-demi'
import { SelectPreviewText } from '../PreviewText'
import Layout from './layout.vue'

const MultipleSelectBase = defineComponent({
  name: 'FMultipleSelectBase',
  props: ['options'],
  setup (props, {attrs, listeners}) {
    return () => {
      return h(
        Layout,
        {
          props: {options: props.options},
          attrs: { ...attrs },
          on: listeners
        },
        []
      )
    }
  }
})

const MultipleSelect = connect(
  MultipleSelectBase,
  mapProps({ dataSource: 'options', loading: true }),
  mapReadPretty(SelectPreviewText, {multiple: true})
)

export default MultipleSelect
